import {
  IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
  } from "@material-ui/core";
  
  import React from "react";
  import { uniqBy } from "lodash/array";
  import { API_URL } from "../../../../constants/api";
  import {
    apiPut,
    apiRequest
  } from "../../../../utils/api_service";
  import {
    SECTIONS,
    SECURITY_SUB_CATEGORY_HEADER,
    getSecuritySubCategoryColumn,
  } from "../../../../constants/appConstants";
  import TableWithFilter from "../../../common/Table/TableWithFilter";
  import { convertIntoDDFormat } from "../../../../utils/generic";
  import { ShowToast, toastType } from "../../../../utils/toast-service";
  import { IsSectionVisible, isGridFormValid } from "../../../../utils/helper";
  import commonLabels from "../../../../constants/messageConstants"
  import _ from "lodash";
  import SaveIcon from "@material-ui/icons/Save";
  import CancelIcon from "@material-ui/icons/Cancel";
  
  export default class SecuritySubCategoryMaintenance extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        colFilteredObj: [],
        subCategoryData: [],
        isInAddMode: false,
        subCategoryColumns: [],
        validationMessage: []
      };
    }
  
    componentDidMount() {
      this.getSubCategoryConfigurations();
    }
    
    /**
     * get routing configuration data
     */
    getSubCategoryConfigurations = () => {
      const params = { incidentParam: "SubCategory" };
      apiRequest({
        url: API_URL.securityIncident.GetSecurityIncidentMasterDataConfiguration,
        params
      }).then(
        ({ data: response }) => {
          const { colFilteredObj } = this.state
          const subCategoryMasterData = uniqBy(
            convertIntoDDFormat(
              response || [],
              "SubCategoryId",
              "SubCategory"
            ),
            x => x.id
          );
          const optionsListForSubCategory = convertIntoDDFormat(
            subCategoryMasterData || [],
            "value",
            "value"
          );
          const columns = getSecuritySubCategoryColumn(colFilteredObj, {
            subCategoryMasterData: optionsListForSubCategory
          });
          this.setState({
            subCategoryData: response,
            subCategoryColumns: columns
          });
        }
      );
    };
  
    /**
     * Add new record
     * @returns 
     */
    AddNewRecord = () => {
      const { isInAddMode, subCategoryColumns, reloadTable } = this.state;
      if (isInAddMode) {
        ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
        return false;
      }

      let newSubCategoryColumns = _.cloneDeep(subCategoryColumns);
      newSubCategoryColumns = newSubCategoryColumns.map(col => {
        if (col.isNonEditable) {
          col.editConfig.isEditField = true;
        }
        return col;
      });
      
      const rowNew = {
        SubCategoryId: 0,
        SubCategory: null,
        IsActive: "Yes"
      };
  
      this.setState({
        isInAddMode: true,
        selectedEditRowId: { key: "SubCategoryId", value: 0 },
        reloadTable: !reloadTable,
        updateData: rowNew,
        subCategoryColumns: newSubCategoryColumns
      });
    };

    /**
     * activate and deactivate the security sub category maintenance record
     */
    activateDeactivateRecord = (data) => {
      const params = {
        SubCategoryId: data.SubCategoryId,
        isActive: data.IsActive === "Yes" ? 2 : 1
      }
      apiPut({
        url: API_URL.securityIncident.ModifySecuritySubCategory,
        params
      }).then(({ data: response }) => {
        response.success != true
          ? ShowToast(
              "Server Error: Unable to update sub category.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Security Sub Category updated successfully.",
              toastType.SUCCESS,
              5000,
              200
            );  
        this.getSubCategoryConfigurations();
      });
    }

   /**
   * handle on change
   * @param {*} value
   * @param {*} fieldName
   */
    handleTableEditChange = (value, fieldName) => {
        const { subCategoryColumns, updateData, validationMessage } = this.state;
        const param = updateData;
        param[fieldName] = value;

        isGridFormValid(value, subCategoryColumns.find(x => x.key === fieldName), param);
       
        this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
          this.forceUpdate();
        });
    };

    /**
    * render action column on grid table
    * @param {*} cellInfo
    * @returns
    */
    renderActionColumn = (cellInfo) => {
      const { selectedEditRowId } = this.state;
      return (
        <>
          {selectedEditRowId !== undefined &&
            cellInfo.SubCategoryId === selectedEditRowId.value
            && (
              <>
                <Tooltip title={"Save Record"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={() => { }}
                  >
                    <SaveIcon
                      fontSize={"small"}
                      size={"small"}
                      onClick={this.saveUpdatedRecord}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Cancel"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={this.cancelEditMode}
                  >
                    <CancelIcon fontSize={"small"} size={"small"} />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      );
    };

   /**
   * cancel row open for edit mode
   */
    cancelEditMode = () => {
      const { reloadTable } = this.state
      this.setState({
        selectedEditRowId: undefined,
        isInAddMode: false,
        updateData: undefined,
        reloadTable: !reloadTable
      });
      this.getSubCategoryConfigurations();
    };

   /**
   * save Updated Record to database
   */
    saveUpdatedRecord = () => {
      const { updateData, reloadTable } = this.state;
      if (!this.isValidForm()) { return false; } 
      else if (this.isAlreadyExist(updateData)){
        return false
      }
      else {
          const newParam = {
            SubCategory: updateData.SubCategory,
            SubCategoryId: updateData.SubCategoryId,
            listOrderBy: Math.floor(Number(updateData.ListOrderBy))
          };
          apiPut({
            url: API_URL.securityIncident.SaveSecurityIncidentSubCategory,
            postBody: newParam
          }
          ).then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                "Record added successfully.",
                toastType.SUCCESS,
                5000,
                500
              );

              this.setState({
                updateData: undefined,
                selectedEditRowId: undefined,
                reloadTable: !reloadTable,
                isInAddMode: false
              }, () => {
                this.getSubCategoryConfigurations();
                this.forceUpdate();
              });
            } else {
              ShowToast(
                response.message,
                toastType.ERROR,
                5000,
                5000
              );
            }
          });
        }      
    };

    /**
     * is Form Valid
    */
    isValidForm = () => {
      let IsValid = true;
      const { updateData, subCategoryColumns } = this.state;
      subCategoryColumns.forEach((ele) => {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      });
      this.setState({ subCategoryColumns }, this.forceUpdate());
      return IsValid;
    };

        /**
     * edit the record
     * @param {*} cellInfo 
     */
      editRecord = (cellInfo) => {
        const { subCategoryColumns, reloadTable } = this.state;
        let newSubCategoryColumns = _.cloneDeep(subCategoryColumns);
        newSubCategoryColumns = newSubCategoryColumns.map(col => {
          if (cellInfo.IsDefault && col.isNonEditable) {
            col.editConfig.isEditField = false;
          }
          return col;
        });

        this.setState({
          subCategoryColumns: newSubCategoryColumns,
          selectedEditRowId: {
            key: "SubCategoryId",
            value: cellInfo.SubCategoryId
          },
          isInAddMode: false,
          updateData:  { ...cellInfo },
          reloadTable: !reloadTable
        });
      }
    
    /**
     * check for exists in the system
     * @param {*} data 
     * @returns 
     */
    isAlreadyExist = (data) => {
      const { subCategoryData } = this.state;
      let fieldName = "";
      let isExist = false;
       if(subCategoryData.find(x=> x.SubCategory === data.SubCategory && x.SubCategoryId !== data.SubCategoryId) !== undefined) {
        fieldName = "Sub Category";
        isExist = true;
       } 
       if(subCategoryData.find(x=> parseInt(x.ListOrderBy) === parseInt(data.ListOrderBy) && x.SubCategoryId !== data.SubCategoryId) !== undefined) {
        fieldName += fieldName === "" ? "List Order by" : ", List Order by";
        isExist = true;
       } 
       if (fieldName != "" && isExist) {
        ShowToast(
          fieldName + " already exist in the system.",
          toastType.ERROR,
          5000,
          500
        );
       }
       return isExist;
    }

    render() {
      const {
        subCategoryData,
        selectedEditRowId,
        updateData,
        isInAddMode,
        reloadTable,
        validationMessage
      } = this.state;
      const {tooltip}=this.props;     
      let { subCategoryColumns } = this.state;
      const isVisible = IsSectionVisible(
        SECTIONS.CONFIGURATION,
        SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );
      subCategoryColumns = !isVisible
        ? subCategoryColumns.filter(x => x.colName !== "Action")
        : subCategoryColumns;
  
      return (
        <>
          <Table
            aria-labelledby={"tableMenuTitle"}
            size={"small"}
            aria-label={"configuration table"}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  key={"configureHeader"}
                  className={"content-header"}
                  colSpan={2}
                >
                  <div className={"content-header d-flex"}>
                    {" "}
                    <div
                      className={"col-xs-11"}
                      style={{ display: "inline-block", alignItems: "center" }}
                    >
                      {"Security Category Maintenance Configuration\r"}
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TableWithFilter
                    renderActionColumn={this.renderActionColumn}
                    selectedEditRowId={selectedEditRowId}
                    isInAddMode={isInAddMode}
                    EditSource={[]}
                    handleTableValueChange={this.handleTableEditChange}
                    updateData={updateData}
                    deactivationMessage={commonLabels.deactivationForSubCategoryConfirmation.message}
                    activationMessage={commonLabels.activationForSubCategoryConfirmation.message}
                    visibilityAction={{
                      isActionVisible: isVisible
                    }}
                    AddNewRecord={{
                      action: this.AddNewRecord,
                      title: "Add Security Sub Category",
                      visible: true
                    }}
                    activateDeactivateRecord={this.activateDeactivateRecord}
                    tableHeader={SECURITY_SUB_CATEGORY_HEADER}
                    columns={subCategoryColumns}
                    originalData={subCategoryData}
                    toolTipData={tooltip}
                    reloadTable={reloadTable}
                    resetPage={this.getSubCategoryConfigurations}
                    validationMessage={validationMessage || []}
                    isInline
                    editRecord={this.editRecord}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      );
    }
  }
  